import { buildURL, validateAndBuildRouteInputs } from "./shared";
import type { NavigateToRouteOpts, RouteToUrlError } from "./shared";
import type { RouteDef } from "@superblocksteam/shared";
import type { Result } from "utils/result";

// E.g: localhost:3000/books/5
export function buildLocalUrlFromRoute(
  route: RouteDef,
  navigateToRoute: NavigateToRouteOpts,
): Result<URL, RouteToUrlError> {
  const result = validateAndBuildRouteInputs(route, navigateToRoute);
  if (!result.ok) {
    return result;
  }

  const url = buildURL({
    targetPath: result.value.path,
    params: result.value.queryParams,
  });

  return {
    ok: true,
    value: url,
  };
}
